(function VolumeByCruiseVendor($, Adzuki)
{
	"use strict";

	var $modal = $(".modal"),
		pages  = ['/Reports/volumeByCruiseVendor', '/Reports/volumeByVendor'];

	$(document).ready(function documentReady()
	{
		Adzuki.onload(pages, function onload()
		{
			$("a.info-link").on('click', function showInfo(e) {
				var vendor_id      = $(this).data("vendor-id"),
					start          = $(this).data("start"),
					end            = $(this).data("end"),
					type           = $(this).data("type"),
					vendor         = $(this).data("vendor"),
					component_type = $(this).data("component-type"),
					url;

				e.preventDefault();

				$modal.find('.modal-title').text("Reservations for " + vendor);
				$modal.addClass('wide');

				if (component_type === '' || component_type === undefined) {
					url = '/Reservations/getReservationsByVendorIdDateAndType/' + vendor_id + '/' + start + '/' + end + '/' + type;
				} else {
					url = '/Reservations/getReservationsByVendorIdDateAndType/' + vendor_id + '/' + start + '/' + end + '/' + type + '/' + component_type;
				}

				Adzuki.Ajax.get(url)
				.then(function getReservationsTable(content) {
					$modal.find('.modal-body').html(content);
				});

				$modal.modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
